import { useSnackbar } from 'notistack';
import { useTranslation } from 'next-i18next';

import { useAppSelector } from '../../../app/hooks/useAppSelector';
import { selectCurrentWorkspaceId } from '../../../slices/workspacesSlice';
import { getSignedPdfLink } from '../../../api/proposalsAPI/api';
import { MessageType } from '../../../components/UI/snackbar/providers/SnackBarProvider';
import { resolveProposalPdfUrl } from './resolveProposalPdf';
import type ProposalEntity from 'src/db/entities/proposal/ProposalEntity';

// A signed quote resolves to its stored signed PDF; anything else goes through `generate`.
export default function useProposalPdfUrl(
  generate: (proposal: ProposalEntity) => Promise<string | undefined>
) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const workspaceId = useAppSelector(selectCurrentWorkspaceId);

  return async (proposal: ProposalEntity): Promise<string | undefined> => {
    try {
      return await resolveProposalPdfUrl(proposal, {
        getSignedLink: (uuid) => getSignedPdfLink(uuid, workspaceId),
        generate,
      });
    } catch (error) {
      const message = !error.response?.status
        ? t('common:message.network_error')
        : t('common:message.server_error');
      enqueueSnackbar({ message, variant: MessageType.Error });
    }
  };
}
